import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-confirm-modal',
  imports: [CommonModule],
  templateUrl: "modal-validation.html"
})
export class ConfirmModalComponent {
  @Input() message: string = 'Are you sure?';
  @Output() close = new EventEmitter<'ok' | 'cancel'>();

  onOk() {
    this.close.emit('ok');
  }

  onCancel() {
    this.close.emit('cancel');
  }
}
